import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Pharmacy } from '@enums/pharmacies';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the GLP-1 treatment type.
 */
export const Glp1Treatment = new TreatmentType({
  id: '9',
  name: ConsultationTreatmentTypes.Glp1,
  restrictedStates: ['AL', 'AR', 'LA', 'MS', 'NC', 'ND', 'VA'],
  restrictedStatesError: 'Starfish.com does not offer GLP-1 in your state at this time.',
  designatedPharmacyId: Pharmacy.CASA_PHARMA,
});
